export default __webpack_public_path__ + "static/media/signup-bg.f43c15cd.jpg";